import React, { memo, useCallback } from 'react';

import { Button } from '@mui/material';
import useSignatureRequestDocumentViewer from 'app/shared/modules/DisclosureDelivery/hooks/useSignatureRequestDocumentViewer';
import PropTypes from 'prop-types';

import useLoanId from 'hooks/useLoanId';

import { LoanCicHistoryTestIds } from '../../../../LoanCicHistory.testIds';

import { PDF_SUFFIX } from './CicDisclosureDocumentLink.constants';
import { documentLinkStyles } from './CicDisclosureDocumentLink.styles';

const CicDisclosureDocumentLink = ({ formDeliveryRequestId, name, sentDate = null }) => {
  const loanId = useLoanId();

  const { onViewDocuments } = useSignatureRequestDocumentViewer({
    loanId,
    signatureId: formDeliveryRequestId,
    fileName: name,
    fileDate: sentDate,
  });

  // The link sits inside a clickable table row; opening the viewer must not also expand the row.
  const onClick = useCallback(
    event => {
      event.stopPropagation();
      onViewDocuments();
    },
    [onViewDocuments],
  );

  return (
    <Button
      data-testid={LoanCicHistoryTestIds.getDisclosureDocumentLinkId(formDeliveryRequestId)}
      size="small"
      sx={documentLinkStyles}
      variant="text"
      onClick={onClick}
    >
      {`${name} ${PDF_SUFFIX}`}
    </Button>
  );
};

CicDisclosureDocumentLink.propTypes = {
  formDeliveryRequestId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sentDate: PropTypes.string,
};

export default memo(CicDisclosureDocumentLink);
